import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-border bg-background mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground">
          <div>
            © 2026 CBAIQ. All rights reserved.
          </div>
          <div className="flex items-center gap-6 flex-wrap justify-center">
            <Link to="/about" className="hover:text-foreground transition-colors">
              About
            </Link>
            <Link to="/how-it-works" className="hover:text-foreground transition-colors">
              How It Works
            </Link>
            <Link to="/faq" className="hover:text-foreground transition-colors">
              FAQ
            </Link>
            <Link to="/pricing" className="hover:text-foreground transition-colors">
              Pricing
            </Link>
            <Link to="/security" className="hover:text-foreground transition-colors">
              Security
            </Link>
            <Link to="/cbaiq-vs-chatgpt" className="hover:text-foreground transition-colors">
              CBAIQ vs ChatGPT
            </Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">
              Terms of Service
            </Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">
              Privacy Policy
            </Link>
            <a 
              href="mailto:support@cbaiq.com" 
              className="hover:text-foreground transition-colors"
            >
              Contact
            </a>
          </div>
        </div>
        <p className="text-xs text-muted-foreground mt-4 text-center sm:text-left" data-testid="footer-disclaimer">
          CBAIQ is an educational decision-support tool, not a law firm, and does not provide legal advice.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
